<template>
  <div align="center" class="wrapper">
    <div class="block-center mt-xl wd-xl">
      <div class="panel panel-dark panel-flat">
        <div class="panel-heading text-center">
          <img src="../assets/calvert-logo.png" alt="Image"
            class="block-center" width="180">
        </div>
        <div class="panel-body">
          <div class="img-container">
              <svg width="151" height="144" xmlns="http://www.w3.org/2000/svg">
                <g fill-rule="nonzero" fill="none">
                  <path d="M11 122h79v10H7c-3 0-5-3-5-5V7c0-3 2-5 5-5h138c3 0 5 2 5 5v78h-9V11H11v111z" fill="#E2E2E2"/>
                  <path d="M7 39v-9h138v9H7zm14-14v-9h9v9h-9zm18 0v-9h9v9h-9z" fill="#E2E2E2"/>
                  <path d="M9 120h79v10H5c-3 0-5-2-5-5V5c0-3 2-5 5-5h138c3 0 5 2 5 5v78h-9V9H9v111z" fill="#00788D"/>
                  <path d="M5 37v-9h138v9H5zm14-14v-9h9v9h-9zm18 0v-9h9v9h-9z" fill="#00788D"/>
                  <g>
                    <path d="M133.9321616 86.51651217h-16.336519v5.44550635h16.336519v-5.44550635zm-10.8910127 35.39579123h5.4455064v-16.336519h-5.4455064v16.336519zm21.8500942-18.0110122l3.8799233-3.8799233c-1.1707838-1.4022179-2.4504778-2.6819119-3.8526957-3.8526957l-3.8799233 3.8799233c-4.1794261-3.3489865-9.5024086-5.3638238-15.2882591-5.3638238-13.545697 0-24.49116478 10.9726953-24.49116478 24.5047786 0 13.5320833 10.94546778 24.5047785 24.49116478 24.5047785 13.5456971 0 24.5183924-10.9726952 24.5183924-24.5047785 0-5.7858505-2.0148374-11.0952192-5.3774376-15.2882591zm-19.127341 34.3475313c-10.523441 0-19.05927223-8.5358312-19.05927223-19.0592722 0-10.523441 8.53583123-19.0592723 19.05927223-19.0592723 10.523441 0 19.0592722 8.5358313 19.0592722 19.0592723s-8.5358312 19.0592722-19.0592722 19.0592722z" fill="#E2E2E2"/>
                    <path d="M131.9321616 84.51651217h-16.336519v5.44550635h16.336519v-5.44550635zm-10.8910127 35.39579123h5.4455064v-16.336519h-5.4455064v16.336519zm21.8500942-18.0110122l3.8799233-3.8799233c-1.1707838-1.4022179-2.4504778-2.6819119-3.8526957-3.8526957l-3.8799233 3.8799233c-4.1794261-3.3489865-9.5024086-5.3638238-15.2882591-5.3638238-13.545697 0-24.49116478 10.9726953-24.49116478 24.5047786 0 13.5320833 10.94546778 24.5047785 24.49116478 24.5047785 13.5456971 0 24.5183924-10.9726952 24.5183924-24.5047785 0-5.7858505-2.0148374-11.0952192-5.3774376-15.2882591zm-19.127341 34.3475313c-10.523441 0-19.05927223-8.5358312-19.05927223-19.0592722 0-10.523441 8.53583123-19.0592723 19.05927223-19.0592723 10.523441 0 19.0592722 8.5358313 19.0592722 19.0592723s-8.5358312 19.0592722-19.0592722 19.0592722z" fill="#8C1D1D"/>
                  </g>
                </g>
              </svg>
            </div>
            <p class="lead">{{ errorDescription }}</p>
            <div v-if="resetPassword">
              <p>The reset password link you were trying to enter is not available anymore. <br>Please, try again.</p>
              <button
                v-on:click="goToResetPassword"
                class="btn btn-default btn-lg mt-lg">Reset password</button>
            </div>
            <div v-if="emailConfirmation">
              <p>The email confirmation link you were trying to enter is not available anymore. <br>Please, try again.</p>
              <div
                v-if="!sentEmailConfirmation"
              >
                <button
                  v-on:click="resendEmailVerification"
                  class="btn btn-default btn-lg mt-lg">Confirm email</button>
              </div>
              <div
                v-if="sentEmailConfirmation"
              >
                <a href="/#/login">
                  <button class="btn btn-default btn-lg mt-lg">Go to login</button>
                </a>
                <p>Email sent. Please check your email.</p>
              </div>

              </div>
          </div>
      </div>
      <p class="mt-lg">If you need more help, please contact Calvert Impact Capital at <a href="mailto:info@calvertimpact.org">info@calvertimpact.org</a> or call us at 800-248-0337.</p>
    </div>
  </div>
</template>

<script>
  import emailErrorsTypes from '@/data/static/emailErrorsTypes';

  export default {
    name: 'ErrorAuth',
    data() {
      return {
        errorDescription: '',
        resetPassword: false,
        emailConfirmation: false,
        email: '',
        sentEmailConfirmation: false,
      };
    },
    mounted() {
      /* eslint-disable camelcase */
      const { error_description, type, message, email } = this.$route.query;
      this.errorDescription = error_description || message || '';
      this.email = email || '';
      this.emailConfirmation = type === emailErrorsTypes.CONFIRMATION_EMAIL.name;
      this.resetPassword = type === emailErrorsTypes.RESET_PASSWORD.name || (!this.emailConfirmation && this.errorDescription.includes('Access expired'));
    },
    methods: {
      goToResetPassword() {
        this.$router.push({ name: 'ResetPassword', query: { email: encodeURIComponent(this.email), resetEmail: true } });
      },
      async resendEmailVerification() {
        await this.$cognitoAuth.resendConfirmationCode(this.email);
        this.sentEmailConfirmation = true;
      },
    },
  };
</script>

<style scoped>

.wd-xl, .panel {
  width: 90%;
  max-width: 420px;
  margin-bottom: 100px;
}

.panel-body {
  padding-top: 10vh;
  padding-bottom: 10vh;
  font-size: 16px;
}

.text-lg {
  font-size: 60px;
  color: #00788d;
}
.text-center .btn {
  min-width: 210px;
  margin: auto;
}
.abs-center {
    height: auto;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.img-container {
    min-height: auto;
    height: 150px;
    width: 150px;
    margin: 20px auto;
    background-color: transparent;
}
.block-center a {
    color: #00788d;
}
</style>



// WEBPACK FOOTER //
// ErrorAuth.vue?bdc99564